// extracted by mini-css-extract-plugin
export default {"data__card":"DataCard_data__card__D2yDz","card__image":"DataCard_card__image__Oc6cr","btn__div":"DataCard_btn__div__bdLvF"};